/*
 * @Descripttion:
 * @version:
 * @Author: zhubaodong
 * @Date: 2021-09-09 20:07:04
 * @LastEditors: zhubaodong
 * @LastEditTime: 2021-09-09 20:07:20
 */
import Vue from "vue";
import Vuex from "vuex";
import teacherEntryFrom from "./modules/teacher-entry-from";
import preference from "./modules/preference";
import payOrder from "./modules/payOrder";
import leaveTime from "./modules/leaveTime";
import closetimelist from "./modules/closeTimeList";
import zhichiCustomer from "./modules/zhichiCustomer";
import smallClassleave from "./modules/smallClassLeave";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    teacherEntryFrom,
    preference,
    payOrder,
    leaveTime,
    closetimelist,
    zhichiCustomer,
    smallClassleave
  }
});
